// extracted by mini-css-extract-plugin
export default {"List":"FinishedRevision_List__+1mea","ConfirmRemoveModalButtons":"FinishedRevision_ConfirmRemoveModalButtons__ByODb","ExportButton":"FinishedRevision_ExportButton__MABS2"};